



























import { Vue } from "vue-property-decorator";

export default Vue.extend({
  name : "InvestLogInfo",
  props: {
    width: { type: String, default: "520px" },
  },
  data() {
    return {
      items  : [],
      title  : "" as string || undefined,
      visible: false,
      loading: false,
      cancel : {
        style   : { display: 'none' },
        disabled: true
      }
    }
  },
  methods: {
    open(id: number, title?: string) {
      this.info(id)
      this.visible = true
      this.title = title == "" ? "审核详情" : title
    },
    async info(id: number) {
      const params = { id }
      const res = await this.$store.dispatch("invest_log/info", params);
      if (res.Code == 200) {
        this.items = res.Data
      }
    }
  }
})

